import React, { useEffect, useState } from "react";
import { Table, Form, Button, Space, Row, Col, Tooltip, Input } from "antd";
import "../Pages/CSS/DonnesBases.css";
import { GestionPaieService } from "../Services/GestionPaieService";
import { DeleteFilled } from "@ant-design/icons";

const ConvCollectives = () => {
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const gestionPaieService = new GestionPaieService();
  const userProfil = localStorage.getItem("profil");

  const fetchAllData = async () => {
    try {
      const modelisation = await gestionPaieService.getAllConv();
      setTableData(modelisation);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    fetchAllData(); 
  }, []);
  
  const handleUpdate = async () => {
    const values = await form.validateFields();
  
    const payload = {
      codeconv: values.codeconv, 
      libconv: values.libconv, 
    };
  
    try {
      const updatedData = await gestionPaieService.updateConv(payload);
      const updatedTableData = tableData.map((item) => {
        if (item.codeconv === payload.codeconv && item.libconv === payload.libconv) {
          return { ...item, ...updatedData };
        }
        return item;
      });
      setTableData(updatedTableData);
      await fetchAllData();
      setEditing(false); 
      form.resetFields(); 
    } catch (error) {
      console.error('Erreur lors de la mise à jour :', error);
    }
  };
  
  const handleAddModelisation = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        codeconv: values.codeconv,
        libconv: values.libconv,
      };
  
      const response = await gestionPaieService.addConv(payload);
      await fetchAllData();
      setEditing(false); 
      form.resetFields(); 
    } catch (error) {
      console.error('Erreur lors de la validation ou de l’ajout de données :', error);
    }
  };

  const handleDelete = async (codeconv) => {
    try {
      await gestionPaieService.deleteConv(codeconv);
      await fetchAllData();
      form.resetFields();
      setEditing(false);
    } catch (error) {
      console.error('Erreur lors de la suppression :', error);
    }
  };

 /*  const columns = [
    {
      title: "Code",
      dataIndex: "codeconv",
      key: "codeconv",
    },
    {
      title: "Libellé",
      dataIndex: "libconv",
      key: "libconv",
    },
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' ? [
      {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: 'actions',
      key: 'actions',
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <span> 
          <Tooltip title="Supprimer">
            <DeleteFilled style={{ cursor: "pointer", color: "red" }} onClick={() => handleDelete(record.codeconv)} />
          </Tooltip>
        </span>
     ),
    },
  ] : []),
].filter(column => column); */
const columns = [
  {
    title: "Code",
    dataIndex: "codeconv",
    key: "codeconv",
    sorter: (a, b) => a.codeconv.localeCompare(b.codeconv),
  },
  {
    title: "Libellé",
    dataIndex: "libconv",
    key: "libconv",
    sorter: (a, b) => a.libconv.localeCompare(b.libconv),
  },
  ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5'
    ? [
        {
          title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                padding: "1px",
              }}
            ></div>
          ),
          dataIndex: 'actions',
          key: 'actions',
          align: "center",
          fixed: "right",
          render: (text, record) => (
            <span>
              <Tooltip title="Supprimer">
                <DeleteFilled
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleDelete(record.codeconv)}
                />
              </Tooltip>
            </span>
          ),
        },
      ]
    : []),
].filter((column) => column);


  const onRowClick = (record) => {
    form.setFieldsValue({
      codeconv: `${record.codeconv}`,
      libconv: `${record.libconv}`,
    });
    setEditing(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditing(false);
  };

  return (
    <div>
       {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              name="codeconv"
              label="Code"
              rules={[{ required: true, message: "Le code est obligatoire" }]}
            >
              <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="libconv"
              label="Libellé"
              rules={[{ required: true, message: "Le libellé est obligatoire" }]}
            >
              <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ display: "flex", justifyContent: "right" }}>
            {editing ? (
              <Space>
                <Button
                  style={{ marginTop: 10 }}
                  type="primary"
                  onClick={handleUpdate}
                  htmlType="submit"
                >
                  Modifier
                </Button>
                <Button style={{ marginTop: 10 }} onClick={handleCancel}>
                  Annuler
                </Button>
              </Space>
            ) : (
              <Space>
                <Button
                  style={{ marginTop: 10 }}
                  type="primary"
                  htmlType="submit"
                  onClick={handleAddModelisation}
                >
                  Enregistrer
                </Button>
              </Space>
            )}
          </Col>
        </Row>
      </Form>
      )}
      <Table
        dataSource={tableData}
        columns={columns}
        showSorterTooltip={false}
        scroll={{ x: true }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        bordered
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
    </div>
  );
};

export default ConvCollectives;
